import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

/**
 * Loads Matterport iframe on mount (shows official cover + play button).
 * Optional thumb image underneath avoids a black flash while the iframe loads.
 * No play=1 — user clicks Matterport's play once to enter the walkthrough.
 */
export default function MatterportEmbed({ embedSrc, thumbUrl, modelId, title }) {
  const [iframeReady, setIframeReady] = useState(false);
  const [thumbSrc, setThumbSrc] = useState(thumbUrl);

  useEffect(() => {
    setThumbSrc(thumbUrl);
    setIframeReady(false);
  }, [thumbUrl, embedSrc]);

  const handleThumbError = () => {
    if (modelId && thumbSrc?.includes('/api/v2/')) {
      setThumbSrc(
        `https://my.matterport.com/api/v1/player/models/${encodeURIComponent(modelId)}/thumb`
      );
    } else {
      setThumbSrc(null);
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        bgcolor: '#2d3748',
        overflow: 'hidden',
      }}
    >
      {thumbSrc && !iframeReady && (
        <Box
          component="img"
          src={thumbSrc}
          alt=""
          onError={handleThumbError}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      )}
      <iframe
        src={embedSrc}
        title={title}
        onLoad={() => setIframeReady(true)}
        allow="fullscreen; xr-spatial-tracking"
        allowFullScreen
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          border: 0,
        }}
      />
    </Box>
  );
}
